import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon, FacebookIcon, InstagramIcon, TwitterIcon, YoutubeIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-gray-900 text-white" data-id="element-76">
      <div className="container mx-auto px-4 py-12" data-id="element-77">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-78">
          {/* Company Info */}
          <div data-id="element-79">
            <h3 className="text-xl font-bold mb-4" data-id="element-80">Forsa Co.</h3>
            <p className="mb-4" data-id="element-81">
              For organizing tourist trips and external tourist guidance.
            </p>
            <div className="flex space-x-4 mt-4" data-id="element-82">
              <a href="#" className="text-white hover:text-blue-400" data-id="element-83">
                <FacebookIcon size={20} data-id="element-84" />
              </a>
              <a href="#" className="text-white hover:text-blue-400" data-id="element-85">
                <InstagramIcon size={20} data-id="element-86" />
              </a>
              <a href="#" className="text-white hover:text-blue-400" data-id="element-87">
                <TwitterIcon size={20} data-id="element-88" />
              </a>
              <a href="#" className="text-white hover:text-blue-400" data-id="element-89">
                <YoutubeIcon size={20} data-id="element-90" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-91">
            <h3 className="text-xl font-bold mb-4" data-id="element-92">Quick Links</h3>
            <ul className="space-y-2" data-id="element-93">
              <li data-id="element-94">
                <Link to="/" className="hover:text-blue-400" data-id="element-95">
                  Home
                </Link>
              </li>
              <li data-id="element-96">
                <Link to="/about" className="hover:text-blue-400" data-id="element-97">
                  About Us
                </Link>
              </li>
              <li data-id="element-98">
                <Link to="/destinations" className="hover:text-blue-400" data-id="element-99">
                  Destinations
                </Link>
              </li>
              <li data-id="element-100">
                <Link to="/packages" className="hover:text-blue-400" data-id="element-101">
                  Packages
                </Link>
              </li>
              <li data-id="element-102">
                <Link to="/contact" className="hover:text-blue-400" data-id="element-103">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          {/* Popular Destinations */}
          <div data-id="element-104">
            <h3 className="text-xl font-bold mb-4" data-id="element-105">Popular Destinations</h3>
            <ul className="space-y-2" data-id="element-106">
              <li data-id="element-107">
                <a href="#" className="hover:text-blue-400" data-id="element-108">
                  Turkey
                </a>
              </li>
              <li data-id="element-109">
                <a href="#" className="hover:text-blue-400" data-id="element-110">
                  Dubai
                </a>
              </li>
              <li data-id="element-111">
                <a href="#" className="hover:text-blue-400" data-id="element-112">
                  Thailand
                </a>
              </li>
              <li data-id="element-113">
                <a href="#" className="hover:text-blue-400" data-id="element-114">
                  Malaysia
                </a>
              </li>
              <li data-id="element-115">
                <a href="#" className="hover:text-blue-400" data-id="element-116">
                  Europe
                </a>
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div data-id="element-117">
            <h3 className="text-xl font-bold mb-4" data-id="element-118">Contact Us</h3>
            <ul className="space-y-3" data-id="element-119">
              <li className="flex items-start" data-id="element-120">
                <PhoneIcon size={18} className="mr-2 mt-1" data-id="element-121" />
                <span data-id="element-122">00965 99886331</span>
              </li>
              <li className="flex items-start" data-id="element-123">
                <MailIcon size={18} className="mr-2 mt-1" data-id="element-124" />
                <span data-id="element-125">george@forsatours.com</span>
              </li>
              <li className="flex items-start" data-id="element-126">
                <MapPinIcon size={18} className="mr-2 mt-1" data-id="element-127" />
                <span data-id="element-128">Kuwait City, Kuwait</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm" data-id="element-129">
          <p data-id="element-130">
            &copy; {new Date().getFullYear()} Forsa Co. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;